import React from 'react';
import { Link } from 'react-router-dom';

export interface FooterLink {
  label: string;
  href: string;
  /** When true, renders as <a target="_blank"> for cross-subdomain or external URLs. */
  external?: boolean;
}

interface AppFooterProps {
  className?: string;
  /** When true, footer sticks to bottom of flex container. When false, flows after content. */
  sticky?: boolean;
  /** Optional override for footer links. When omitted, falls back to portal's default link set. */
  links?: FooterLink[];
}

const PORTAL_DEFAULT_LINKS: FooterLink[] = [
  { label: 'User Guides', href: '/docs' },
  { label: 'Support', href: '/docs/support' },
  { label: 'Getting Started', href: '/docs/getting-started' },
  { label: 'Terms of Service', href: '/docs/legal/terms' },
  { label: 'Privacy Policy', href: '/docs/legal/privacy' },
  { label: 'Acceptable Use', href: '/docs/legal/acceptable-use' }
];

// eslint-disable-next-line max-lines-per-function
export const AppFooter: React.FC<AppFooterProps> = ({
  className = '',
  sticky = true,
  links = PORTAL_DEFAULT_LINKS
}) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className={`bg-muted/30 border-t border-border ${sticky ? 'mt-auto' : ''} ${className}`}
    >
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='py-3'>
          <div
            className='flex flex-wrap items-center justify-center gap-x-4 gap-y-2
              text-sm text-muted-foreground'
          >
            {links.map(link => (
              <React.Fragment key={`${link.label}:${link.href}`}>
                {link.external ? (
                  <a
                    href={link.href}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='hover:text-foreground transition-colors'
                  >
                    {link.label}
                  </a>
                ) : (
                  <Link to={link.href} className='hover:text-foreground transition-colors'>
                    {link.label}
                  </Link>
                )}
                <span className='text-muted-foreground/50'>|</span>
              </React.Fragment>
            ))}

            {/* Copyright */}
            <span className='text-muted-foreground'>© {currentYear} Kebi AI LLC</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
